/** Semantic stroke colors for inline SVG icons (menus, nav, row actions). */
const ICON_COLORS = {
    "arrow-left": "#6b7280",
    cart: "#2563eb",
    package: "#0891b2",
    heart: "#e11d48",
    "heart-filled": "#e11d48",
    "map-pin": "#2563eb",
    user: "#6366f1",
    lock: "#d97706",
    store: "#1f6f4a",
    mail: "#0284c7",
    "clipboard-list": "#0d9488",
    box: "#ea580c",
    layers: "#7c3aed",
    users: "#4f46e5",
    star: "#ca8a04",
    truck: "#0d9488",
    "file-text": "#64748b",
    eye: "#0369a1",
    "eye-off": "#94a3b8",
    pencil: "#ca8a04",
    trash: "#b42318",
    download: "#059669",
    upload: "#16a34a",
    "x-circle": "#b42318",
    x: "#b42318",
    "log-in": "#1f6f4a",
    "log-out": "#b42318",
    "user-plus": "#16a34a",
    "user-check": "#16a34a",
    "user-minus": "#b42318",
    share: "#1f6f4a"
};

const DANGER_COLOR = "#b42318";
const ACTIVE_ON_PRIMARY = "#ffffff";

/**
 * @param {string|null|undefined} iconName
 * @param {{ danger?: boolean, active?: boolean }} [options]
 */
export function colorForIcon(iconName, { danger = false, active = false } = {}) {
    if (!iconName) {
        return undefined;
    }
    if (active) {
        return ACTIVE_ON_PRIMARY;
    }
    if (danger) {
        return DANGER_COLOR;
    }
    return ICON_COLORS[iconName] ?? "#6b7280";
}
